var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showGifts)?_c('product-sale-view',_vm._g(_vm._b({},'product-sale-view',_vm.productProps,false),_vm.productListeners)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }